import { ConfigProvider } from '@fe/armor_component';
import { useContext } from 'react';
import { AppContext } from '../app/app-layout';
export default (<T = AppContext,>() => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (useContext((ConfigProvider.ConfigContext as any)) as T);
});